import { useEffect, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";

import { IconButton, Tooltip, makeStyles } from "@material-ui/core";
import CheckOutlined from "@material-ui/icons/CheckOutlined";
import Copy from "@material-ui/icons/FileCopy";

const useStyles = makeStyles(() => ({
  text: {
    marginLeft: "5px"
  }
}));

export default function ClickToCopy({ text }: { text: string }): JSX.Element {
  const [copied, setCopied] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (copied) {
      const handle = setTimeout(() => setCopied(false), 3000);
      return () => clearTimeout(handle);
    }
  });

  return (
    <CopyToClipboard text={text} onCopy={() => setCopied(true)}>
      <span>
        <Tooltip title={copied ? "Copied" : "Copy to clipboard"}>
          <IconButton>{copied ? <CheckOutlined /> : <Copy />}</IconButton>
        </Tooltip>
        <span className={classes.text}>{text}</span>
      </span>
    </CopyToClipboard>
  );
}
